import { resultsDuckCreator } from 'axl-ducks';

import { invDuckPreset } from '@/ducks/presets/index.js';

export default resultsDuckCreator({
    ...invDuckPreset,
    store: 'activeEmailListing',
});
